import React from 'react';
import ReactDOM from 'react-dom/client'; // ReactDOM 18+ uses 'createRoot' method
import App from './App'; // Import your main App component

// Create the root container and render the App component
const root = ReactDOM.createRoot(document.getElementById('root')); // Get the 'root' div
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
